import { all, takeEvery, put, select } from 'redux-saga/effects';
import { addRoutes } from 'redux-first-router';
import _ from 'lodash';
import { constants as deviseActionConst } from '../../devise/store/notification/actions';
import { actions as userActions } from '../../core/store/User/actions';
import { getAppConfig } from '../lib/appsRegistry';
import { AUTH_TOKEN } from '../../shared/constants/network';
import buildRoutesMap from '../setup/routes';
import { actions as snackActions } from '../../core/store/Snack/actions';

const getCompany = ({ company }) => company;

function* handleLoginSucceed({ payload }) {
  const { user, authToken } = payload;
  localStorage.setItem(AUTH_TOKEN, authToken);
  yield put(userActions.setUserProfile(user));
  window.dataLayer.push({
    user_id: _.get(user, 'id'),
    company: _.chain(user)
      .get('email')
      .split('@')
      .get(1)
      .value(),
  });
  const company = yield select(getCompany);
  const { subdomain } = company;
  const appConfig = yield getAppConfig({ companyName: subdomain });

  // Reload routes
  const routesMap = yield buildRoutesMap({
    companyName: subdomain,
    user: { userProfile: user },
  });
  yield put(addRoutes(routesMap));

  const { afterSigninAction } = appConfig;
  yield put(afterSigninAction());
}

function* handleApolloError({ networkError, graphQLErrors }) {
  if (networkError) {
    yield put(
      snackActions.enqueueSnackbar({
        message: _.get(
          networkError,
          'result.error.message',
          'Oops, something went wrong'
        ),
        options: {
          variant: 'error',
        },
      })
    );
  } else if (graphQLErrors) {
    const visibleErrors = _.filter(
      graphQLErrors,
      e => _.get(e, 'extensions.type') === 'visible'
    );
    const errorMessage = _.map(visibleErrors, 'message').join(', ');
    if (!_.isEmpty(errorMessage)) {
      yield put(
        snackActions.enqueueSnackbar({
          message: errorMessage,
          options: {
            variant: 'error',
          },
        })
      );
    }
  }
}

function* watchLoginSucceed() {
  yield takeEvery(deviseActionConst.loginSucceeded, handleLoginSucceed);
}

function* watchUpdateSucceeded() {
  yield takeEvery(deviseActionConst.updateSucceeded, handleLoginSucceed);
}

function* watchApolloError() {
  yield takeEvery('apollo.error', handleApolloError);
}

const controlSaga = function* saga() {
  yield all([watchLoginSucceed(), watchUpdateSucceeded(), watchApolloError()]);
};

export default controlSaga;
